module.exports = __webpack_public_path__ + "static/media/box_in1.2446c53b.png";